import { useContext, useEffect, useState } from 'react';

import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import type { TRect } from '@src/types/misc';

type TProps = TRect | Record<string, never>;

function useDomLocationInWysiwygContainer({
  height = null,
  width = null,
  x = null,
  y = null
}: TProps): null | TRect {
  const { renderRect } = useContext(WysiwygEditorStateContext);
  const [location, setLocation] = useState<TRect>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!renderRect) return;
    if (height === null) return;
    if (width === null) return;
    if (x === null) return;
    if (y === null) return;

    setLocation({
      x: x * renderRect.width,
      y: y * renderRect.height,
      height: height * renderRect.height,
      width: width * renderRect.width
    });
  }, [height, width, x, y, renderRect]);

  return location;
}

export default useDomLocationInWysiwygContainer;
